import { Text } from '@urbaninfrastructure/react-ui-kit';

export default Text;
